import RpcService  from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';

import type Characteristic     from '@/domains/Characteristics/Characteristic';
import type RpcDataPagination  from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort        from '@/core/services/Rpc/RpcDataSort';

/**
 * DAO для работы с рамками характеристик (catalog.characteristics)
 */
class CharacteristicsDAO {

	static async getList(
		filters?: {
      id?: number;
      pattern?: string;
      name?: string;
      isDeleted?: boolean;
      groupId?: number;
      onlyEmpty?: boolean;
    },
		pagination?: RpcDataPagination,
		sort?: RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
			'characteristics.getList',
      {
        ...filters,
      },
			pagination,
			sort,
			true, null, null, false,
			{ abortPrevious: true },
		);
	}

	/**
	 * Получить рамки характеристик, привязанные к категории и/или продукту.
	 * В отличие от getList (админ-реестр с фильтрами/пагинацией), это узкий эндпоинт
	 * для потребителей-сущностей
	 */
	static async getAttachedList(params?: {
		categoryId?: number;
		productId?: number;
	}): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristics.getAttachedList', params ?? {});
	}

	static async add(characteristic: Characteristic): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristics.add', { characteristic });
	}

	static async update(characteristic: Characteristic): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristics.update', { characteristic });
	}

	static async setGroup(characteristicId: number, groupId: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristics.setGroup', { characteristicId, groupId });
	}

	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristics.delete', { id });
	}

	static async isRequiredUpdate(
		characteristicId: number,
		productCategoryId: number,
		isRequired: boolean,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristics.isRequiredUpdate', {
			characteristicId,
			productCategoryId,
			isRequired,
		});
	}

	static async changeSort(
		movedElementId: number,
		targetElementId: number,
		insertAfter: boolean,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristics.changeSort', {
			movedElementId,
			targetElementId,
			insertAfter,
		});
	}

}

export default CharacteristicsDAO;
